var _g;
import * as React from "react";
var SvgOtherPlatformsCustom = function SvgOtherPlatformsCustom(props) {
  return _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFC53D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 3.519V2.87c0-.185.208-.37.417-.37h.833c.208 0 .417.185.417.37v1.297M12.099 4.255a1.102 1.102 0 0 0-.864 0L6.667 7.433v3.885c0 .706.493 1.177 1.234 1.177h1.852v1.177h.988v1.06l-.618.823 1.112.824-.988.706v1.295l.494.706v1.295l-.494.706 1.358 1.413h.864l1.111-1.295v-8.828h1.852c.74 0 1.235-.47 1.235-1.177V7.315l-4.568-3.06ZM9.877 9.787c0-.588.493-1.06 1.11-1.06h1.359c.617 0 1.11.472 1.11 1.06v1.884h-3.58V9.787Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.623 7.496c-.111 0-.222 0-.334-.107l-5.222-3.507c-.111-.107-.333-.107-.445-.107-.11 0-.333 0-.444.107L5.955 7.389c-.333.213-.777.107-.889-.212-.11-.32-.11-.638.223-.85l5.222-3.508c.334-.106.667-.319 1.111-.319.445 0 .89.106 1.223.319l5.222 3.507a.547.547 0 0 1 .111.85.616.616 0 0 1-.555.32Z"
  }))));
};
export default SvgOtherPlatformsCustom;